import React, {Component} from "react";
import {Button, Icon, Input} from "antd";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import {urlPath} from "./Settings";
import {getAuthHeader} from "../utils/security";
import {copyToClipboard, updateProofLink} from "./Helpers";
import {connect} from "react-redux";
import {setFieldsToSave, setMatspecsToSubmit} from "../redux/actions";
import {debounce} from "lodash";

library.add(faCode);

const {TextArea} = Input;

const mapDispatchToProps = (dispatch) => {
	return {
		setFieldsToSave: (key) => dispatch(setFieldsToSave(key)),
		setMatspecsToSubmit: (key) => dispatch(setMatspecsToSubmit(key)),
	};
};

const mapStateToProps = (state) => {
	return {
		fieldsToSave: state.fieldsToSave,
		matspecsToSubmit: state.matspecsToSubmit,
	};
};

class PartyInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fieldsToSave: [],
			urlArray: [],
			translations: {},
			prooflinkDisabled: true,
		};
	}

	copyUrlToClipboard = (e) => {
		const input = e.target
			.closest(".ant-input-group-wrapper")
			.querySelectorAll("input")[0];
		if (!input.value || input.value.length === 0) input.value = "N/A";
		input.select();
		document.execCommand("copy");
	};

	fillUrlField = (value) => {
		if (!value.startsWith("http")) {
			if (value.startsWith("www.") || value.endsWith(".com"))
				value = "http://" + value;
		}
		return value;
	};

	admaterialUpdate = debounce((target, admaterial, field, value, matspecId) => {
		const paramss = {target, admaterial, field, value, matspecId};
		console.log(matspecId);
		this.props.setFieldsToSave({...this.props.fieldsToSave, [field]: paramss});
		this.props.setMatspecsToSubmit({
			...this.props.matspecsToSubmit,
			[this.props.specId]: true,
		});
	}, 350);

	getFields = (matspec) => {
		let urlMatspec = "";
		if (matspec) urlMatspec = "&matspec=" + matspec;
		const urlFields = document
			.getElementById("partyInfourlsContainer." + this.props.id)
			.querySelectorAll("input.ant-input");
		const urlExistingFields = document
			.getElementById("urlsExistingContainer." + this.props.id)
			.querySelectorAll("input.ant-input");
		const firstUrl = document.getElementById("partyTagInputUrl." + this.props.id).value;
		let urlsToSave = "&userurl=" + encodeURIComponent(firstUrl);
		if (urlFields && urlFields.length > 0) {
			for(let i = 0; i < urlFields.length; i++) {
				if (urlFields[i].value.length > 0)
					urlsToSave += "&userurl=" + encodeURIComponent(urlFields[i].value);
			}
		}
		if (urlExistingFields && urlExistingFields.length > 0) {
			for(let i = 0; i < urlExistingFields.length; i++) {
				if (urlExistingFields[i].value.length > 0)
					urlsToSave += "&userurl=" + encodeURIComponent(urlExistingFields[i].value);
			}
		}
		console.log(urlsToSave);
		if (!this.props.id || this.props.id < 1)
			console.error("Wrong AdMaterial." + this.props.id);
		else
			fetch(urlPath + "/api/admaterialupdate?admaterial=" + this.props.id + urlsToSave + urlMatspec,
				{method: "PUT", credentials: "include", headers: getAuthHeader(),})
				.then((response) => response.json())
				.then((data) => {
					if (document.getElementById("partyTagInputUrl." + this.props.id))
						document
							.getElementById("partyTagInputUrl." + this.props.id)
							.classList.add("field-valid");
					for(let i = 0; i < urlFields.length; i++) {
						urlFields[i].classList.add("field-valid");
					}
				})
				.catch((e) => console.error("Cannot update material", e));
	};
	checkValidUrl = (url, admaterial) => {
		const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
		const target = document.getElementById("validPartyTagUrl" + admaterial);
		if (!target) return true;
		if (!pattern.test(url) && url !== "") {
			target.classList.remove("d-none");
			target.classList.add("error-msg");
			console.log("Please enter a valid URL.");
			return false;
		} else {
			target.classList.add("d-none");
			target.classList.remove("error-msg");
			return true;
		}
	};
	deleteUrl = (e) => {
		const id = e.target.closest(".url-container").id;
		const urlContainerId = document.getElementById(id);
		//urlContainerId.remove();
		urlContainerId.querySelectorAll(".newUrlInput")[0].value = "";
		//urlContainerId.classList.add('d-none');
		//urlContainerId.querySelectorAll('.newUrlInput')[0].classList.add('d-none');
		this.getFields();
	};
	addUrlField = (e) => {
		console.log("Adding new url");
		const urlArray = this.state.urlArray;
		const id = Math.floor(Math.random() * 1000000);
		urlArray.push(
			<span key={urlArray.length}
			      id={"urlContainerId." + id}
			      className="url-container"
			>
                <Input
	                id={id}
	                className="partyTag-input newUrlInput saveUrlInput"
	                placeholder={this.props.translations.placeUrl}
	                onChange={(e) => this.admaterialUpdate(e.target, id, "userurl", e.target.value)}
	                addonAfter={
		                <span>
                            {this.props.internal && (
	                            <Icon className="copy-url-button"
	                                  type="copy"
	                                  onClick={this.copyUrlToClipboard}
	                            />
                            )}
			                <Icon onClick={(e) => this.deleteUrl(e)}
			                      className="delete-url"
			                      type="delete"
			                />
                        </span>
	                }
                />
                <span className="d-none" id={"validPartyTagUrl" + id}>
                    {this.props.translations.invalidUrl}
                </span>
            </span>
		);
		this.setState({urlArray: urlArray,});
		e.stopPropagation();
	};

	removeLists = () => {
		this.setState({urlArray: []});
		//if(document.getElementById('urlsExistingContainer.' + this.props.id))
		//  document.getElementById('urlsExistingContainer.' + this.props.id).innerHTML = '';
	};

	componentWillReceiveProps(nextProps) {
		//console.log(this.props.id === nextProps.id);
		//this.loadMaterial();
		//this.getPartyTag();
	}

	componentDidMount() {
		console.log("Party info mounted");
		this.loadMaterial();
	}

	componentDidUpdate(prevProps) {
		//console.log("updated");
	}

	componentWillUnmount() {
		console.log("unmounting");
	}

	loadMaterial = () => {
		if (this.props.id > 0) {
			fetch(urlPath + "/api/loadadmaterial?admaterial=" + this.props.id + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
				{credentials: "include", headers: getAuthHeader(),}
			)
				.then((response) => response.json())
				.then((data) => {
					const {inputfilename} = data;
					console.log(inputfilename, RegExp(/index.html/gm).test(inputfilename));

					if (inputfilename && (inputfilename.startsWith("thirdpartytag_") || inputfilename.startsWith("vpaid_") || inputfilename.startsWith("vast_")))
						this.getPartyTag();
					this.setState({
						render: true,
						pixeltrackerValue: data.pixeltracker,
						descriptionValue: data.description,
						proofLinkValue: data.prooflink,
						userurlValue: data.userurls[0],
						userurls: data.userurls,
						sgCodeValue: data.sgcode && !isNaN(data.sgcode) && data.sgcode !== 0? data.sgcode: "",
					});

					if (
						inputfilename &&
						RegExp(/index.html/gm).test(inputfilename)
					) {
						const findClickTagUrl = (data) => {
							if (data && data.original) {
								const indexFile = data.original.filter((file) => file.serverfilename === "index.html");
								return (
									(indexFile &&
										indexFile[0].htmlattributes &&
										indexFile[0].htmlattributes.clicktag) ||
									false
								);
							} else {
								return false;
							}
						};

						this.setState({
							render: true,
							pixeltrackerValue: data.pixeltracker,
							descriptionValue: data.description,
							proofLinkValue: data.prooflink,
							userurlValue: findClickTagUrl(data),
							userurls: data.userurls,
							sgCodeValue: data.sgcode && !isNaN(data.sgcode) && data.sgcode !== 0? data.sgcode: "",
						});
					}
				})
				.catch((e) => {
					this.setState({render: true,});
					console.error("Cannot load material!");
				});
		} else {
			this.setState({render: true,});
		}
	};

	getPartyTag = () => {
		console.log(this.props.id);
		if (this.props.id > 0)
			fetch(urlPath + "/api/loadadmaterial-3party?admaterial=" + this.props.id + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
				{credentials: "include", headers: getAuthHeader()})
				.then((response) => {
					if (response.ok) {
						return response.text();
					} else {
						this.setState({partyTagCode: ""});
					}
				})
				.then((data) => {
					if (data)
						this.setState({
							partyTagInitialCode: data,
							partyTagCode: data,
							partyTagFilled: data.length > 0,
						});
				})
				.catch((e) => console.error("Cannot load partytag!", e));
	};

	copyToClipboard = (e) => {
		const input = e.target
			.closest("#partytagTextarea")
			.querySelectorAll("textarea")[0];
		if (!input.value || input.value.length === 0)
			input.value = input.getAttribute("placeholder");
		input.select();
		document.execCommand("copy");
	};

	updatingProofLink = (e) => {
		this.setState({updatingProofLink: true});
		setTimeout(() => this.setState({updatingProofLink: false}), 2500);
	};

	handlePartyChange = (e) => {
		this.setState({partyTagCode: e.target.value});
		this.props.partyTagUpdateOnChange(e, "partytag", this.state.partyTagInitialCode);
	};

	render() {
		const {inputfilename, userurls, description, pixeltracker, sgCode,} = this.props;
		const partyModalHasContent =
			(inputfilename && inputfilename.includes("thirdparty")) ||
			(userurls && userurls.length > 0) ||
			(description && description.length) > 0 ||
			(pixeltracker && pixeltracker.length > 0) ||
			(sgCode && sgCode.length > 0);
		if (!this.state.render)
			return (
				<Icon
					style={{display: "block", margin: " 25px auto"}}
					type="loading"
				/>
			);
		console.log("thirdpart_tags state ==> ", this.state);

		return (
			<div id="partyInfoContainer">
				{this.props.showPartytagTextarea && (
					<div id="partytagTextarea">
						<TextArea
							placeholder={this.props.translations.partyTag}
							id={"partytagIinput." + this.props.id}
							rows={6}
							value={this.state.partyTagCode}
							onChange={this.handlePartyChange}
							disabled={/*this.props.id < 0*/ false}
						/>
						{this.props.internal && (
							<Button
								style={{float: "right", margin: "5px 0"}}
								onClick={(e) => this.copyToClipboard(e)}
								size="small"
								type="primary"
							>
								<Icon type="copy"/>
							</Button>
						)}
					</div>
				)}
				{this.props.showSGCode && (
					<div>
						<Input
							id={"sgCodeInput." + this.props.id}
							addonBefore={this.props.translations.sgCode}
							className="partyTag-input input__disabled"
							placeholder={this.props.translations.sgCode}
							value={this.state.sgCodeValue}
							addonAfter={
								<Icon className="pointer blue" type="copy" onClick={(e) => copyToClipboard(e)}/>
							}
						/>
						<span className={this.state.sgErrorField? "sgErrorMessage": "d-none"}>
                            {this.props.translations.sgError}
                        </span>
					</div>
				)}
				<Input
					addonBefore={this.props.translations.pixeltracker}
					className="partyTag-input"
					placeholder={this.props.translations.pixeltracker}
					value={
						this.state.pixeltrackerValue &&
						this.fillUrlField(this.state.pixeltrackerValue)
					}
					onChange={(e) => {
						this.setState({pixeltrackerValue: this.fillUrlField(e.target.value),});
						this.admaterialUpdate(e.target, this.props.id, "pixeltracker", this.fillUrlField(e.target.value));
					}}
					addonAfter={
						<span>
                            {this.props.internal && (
	                            <Icon
		                            className="pointer blue copy-url-button"
		                            type="copy"
		                            onClick={(e) => copyToClipboard(e)}
	                            />
                            )}
							<Icon type="check-circle"/>
                        </span>
					}
				/>
				<TextArea
					id={"partyTagInputDescription." + this.props.id}
					className="partyTag-input"
					placeholder={this.props.translations.description}
					value={this.state.descriptionValue}
					style={{marginTop: "10px"}}
					onChange={(e) => {
						this.setState({descriptionValue: e.target.value});
						this.admaterialUpdate(e.target, this.props.id, "description", e.target.value);
					}}
				/>
				{(this.props.loadConfig["web.campaign.showprooflink"] ||
					this.state.proofLinkValue) && (
					<Input
						disabled={this.state.prooflinkDisabled}
						addonBefore={this.props.translations.prooflink? this.props.translations.prooflink: "Proof link"}
						className="partyTag-input"
						placeholder={this.props.translations.url}
						value={this.state.proofLinkValue}
						onChange={(e) => {
							this.setState({proofLinkValue: e.target.value});
							updateProofLink(this.props.id, e.target.value);
							this.updatingProofLink();
						}}
						addonAfter={
							<div>
								{this.props.internal && (
									<Icon
										className="pointer blue"
										type={this.state.updatingProofLink? "loading": "edit"}
										onClick={() => this.setState({prooflinkDisabled: false,})}
									/>
								)}
							</div>
						}
					/>
				)}
				<Input
					id={"partyTagInputUrl." + this.props.id}
					addonBefore={this.props.translations.url}
					className="partyTag-input"
					placeholder={this.props.translations.url}
					value={
						this.state.userurlValue &&
						this.fillUrlField(this.state.userurlValue)
					}
					onChange={(e) => {
						this.setState({userurlValue: this.fillUrlField(e.target.value),});
						this.admaterialUpdate(e.target, this.props.id, "userurl", this.fillUrlField(e.target.value));
					}}
					addonAfter={
						<div>
							{this.props.internal && (
								<Icon
									className="copy-url-button"
									type="copy"
									onClick={this.copyUrlToClipboard}
								/>
							)}
							<Icon type="check-circle"/>
						</div>
					}
				/>
				<span className="d-none" id={"validPartyTagUrl" + this.props.id}>
                    {this.props.translations.invalidUrl}
                </span>

				<div id={"partyInfourlsContainer." + this.props.id}>
					{this.state.urlArray}
				</div>
				<div id={"urlsExistingContainer." + this.props.id}>
					{this.state.userurls &&
					this.state.userurls.map(
						(item, index) =>
							index > 0 && (
								<span
									key={index}
									id={"urlContainerId." + index}
									data-key={index}
									className="url-container"
								>
                                        <Input
	                                        style={{marginTop: "10px"}}
	                                        id={"url." + index}
	                                        className="partyTag-input newUrlInput saveUrlInput"
	                                        onChange={(e) => {
		                                        const newValId =
			                                        "newValId" + index;
		                                        this.setState({[newValId]: e.target.value,});
		                                        this.admaterialUpdate(e.target, "url." + index, "userurl", e.target.value);
	                                        }}
	                                        value={this.state["newValId" + index]? this.state["newValId" + index]: this.state.userurls[index]}
	                                        addonAfter={
		                                        <span>
                                                    {this.props.internal && (
	                                                    <Icon
		                                                    className="copy-url-button"
		                                                    type="copy"
		                                                    onClick={this.copyUrlToClipboard}
	                                                    />
                                                    )}
			                                        <Icon
				                                        onClick={(e) => this.deleteUrl(e)}
				                                        className="delete-url"
				                                        type="delete"
			                                        />
                                                </span>
	                                        }
                                        />
                                    </span>
							)
					)}
				</div>
				<div className="text-right">
					<Button
						size="small"
						type="default"
						className="addUrl-button d-none"
						onClick={(e) => this.addUrlField(e)}
					>
						<Icon type="plus-circle"/>
						<span data-translationkey="addUrl">
                            {this.props.translations.addUrl}
                        </span>
					</Button>
				</div>
				<div className="text-right">
					<Button
						size="small"
						type="default"
						style={{marginTop: "10px"}}
						onClick={(e) => this.admaterialUpdate(e.target, this.props.id, "userurl", this.state.userurlValue, this.props.specId)}
					>
						<Icon type="plus-circle"/>
						<span data-translationkey="copyUrlToAll">
                            {this.props.translations.copyUrlToAll || "Copy url to all creatives"}
                        </span>
					</Button>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PartyInfo);



// WEBPACK FOOTER //
// ./src/components/PartyInfo.js